import { render, staticRenderFns } from "./product-item.vue?vue&type=template&id=253c1b34&scoped=true&"
import script from "./product-item.vue?vue&type=script&lang=js&"
export * from "./product-item.vue?vue&type=script&lang=js&"
import style0 from "./product-item.vue?vue&type=style&index=0&id=253c1b34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253c1b34",
  null
  
)

export default component.exports